/* eslint-disable no-prototype-builtins */
export default class Errors {
    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
    }


    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    /**
     * Determine if an errors exists for the given field and returns
     * a 'error' string to be used as a classname.
     *
     * @param {string} field
     */
    class(field) {
        return this.errors.hasOwnProperty(field) ? 'form__input--has-error' : '';
    }


    /**
     * Determine if we have any errors.
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }


    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */
    get(field) {
        if (!this.errors[field]) {
            return null;
        }

        return this.errors[field][0];
    }

    scrollToFirstError(el) {
        zenscroll.to(el, 800);
    }

    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    record(errors) {
        this.errors = errors;
    }


    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
    clear(field) {
        if (field) {
            delete this.errors[field];

            return;
        }

        this.errors = {};
    }
}